import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let endpoint = document.body.dataset.nossPopup;
    fetch(endpoint, {
        method: 'GET',
    })
    .then(function (response) {
        return response.json();
    })
    .then(function (data) {
        if (data) {
            setTimeout(function() {
                bootstrap.Modal.getOrCreateInstance(document.querySelector('[id^="noss_popup_modal"][data-pid="' + data + '"]')).show();
            }, 500);
        }
    });
}